var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHierarchy(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 40 40",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M11.667 13.333h-5A3.343 3.343 0 0 1 3.334 10V6.666c0-1.833 1.5-3.333 3.333-3.333h5c1.834 0 3.334 1.5 3.334 3.333V10c0 1.833-1.5 3.333-3.334 3.333m22.999-1.666h-6c-1.1 0-2-.9-2-2V7c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v2.667c0 1.1-.9 2-2 2m0 12.5h-6c-1.1 0-2-.9-2-2V19.5c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v2.667c0 1.1-.9 2-2 2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 10,
    strokeWidth: 3,
    d: "M15 8.333h11.667m-5.833 0V30c0 1.833 1.5 3.333 3.333 3.333h2.5m-5.833-12.5h5.833"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M34.666 36.667h-6c-1.1 0-2-.9-2-2V32c0-1.1.9-2 2-2h6c1.1 0 2 .9 2 2v2.667c0 1.1-.9 2-2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHierarchy);
export default __webpack_public_path__ + "static/media/hierarchy.f4fb0f332bc37638bc51bd66c0e50fbd.svg";
export { ForwardRef as ReactComponent };